import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';

import { CUSTOMER_LIST_FETCH, CUSTOMER_LIST_FETCH_FAILED, CUSTOMER_LIST_RECEIVE } from './customer-list-actions';
import { CustomerListItem } from '../models/customer-list-item';

export interface CustomerListReducerState {
    items: PaginatedResponse<CustomerListItem>;
    requesting: boolean;
}

const initialCustomerListReducerState: CustomerListReducerState = {
    items: { limit: 10, page: 0, total: 0, items: [] },
    requesting: false,
};

export const customerListReducer = (
    state: CustomerListReducerState = initialCustomerListReducerState,
    action: AnyAction
): CustomerListReducerState => {
    switch (action.type) {
        case CUSTOMER_LIST_FETCH: {
            return {
                ...state,
                requesting: true,
            };
        }

        case CUSTOMER_LIST_RECEIVE: {
            return {
                ...state,
                requesting: false,
                items: action['customers'],
            };
        }

        case CUSTOMER_LIST_FETCH_FAILED: {
            return {
                ...state,
                requesting: false,
            };
        }

        default: {
            return state;
        }
    }
};
